import moment from "moment";

export default {
  collection_from_data(data, text_field, value_field) {
    // console.log('CFD: ', data);
    if (value_field === undefined) value_field = 'id';
    if (text_field === undefined) text_field = 'name';
    let collection = [];
    collection = _.map(data, function(el){
      return {value: el[value_field], text: el.attributes[text_field]}
    });
    // console.log('create_collection from api helper - ', collection);
    return collection;
  },

  format_date(date, input_format='YYYY-MM-DD', output_format="DD.MM.YYYY"){
    return moment(date, input_format).format(output_format)
  },

}